function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#approval-detail-card_svg__clip0_175839_243713)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.5 3.5L5 1v2.5H2.5z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.5 4l3-3H13v13H2l.5-10z",
  fill: "#8F90A6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.25 9.75a3 3 0 100 6 3 3 0 000-6z",
  fill: "#8F90A6",
  stroke: "#fff",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.573 11.573l-1.822 1.825-.823-.822a.25.25 0 00-.352.352l1 1a.25.25 0 00.352 0l2-2a.25.25 0 00-.352-.352l-.003-.003z",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 4V1L2 4h3z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.5 9.75v-8.5a.75.75 0 00-.75-.75H5.415a1.25 1.25 0 00-.885.365L2.365 3.03A1.25 1.25 0 002 3.915v9.835a.75.75 0 00.75.75h6.765A3.25 3.25 0 1013.5 9.75zM4.885 1.22A.75.75 0 015 1.125V3.25a.25.25 0 01-.25.25H2.625a.75.75 0 01.095-.115L4.885 1.22zM2.75 14a.25.25 0 01-.25-.25V4h2.25a.75.75 0 00.75-.75V1h7.25a.25.25 0 01.25.25v8.34A3.25 3.25 0 009.25 14h-6.5zm9.5 1.5a2.75 2.75 0 110-5.5 2.75 2.75 0 010 5.5z",
  fill: "#8F90A6",
  stroke: "#8F90A6",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.25 5.5h-1a.25.25 0 000 .5h1a.25.25 0 000-.5zm-6 .5h4a.25.25 0 000-.5h-4a.25.25 0 000 .5zm0 1h5a.25.25 0 000-.5h-5a.25.25 0 000 .5zM8.5 9H4.25a.25.25 0 000 .5H8.5a.25.25 0 000-.5zm1.25-1h-5.5a.25.25 0 000 .5h5.5a.25.25 0 000-.5z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "approval-detail-card_svg__clip0_175839_243713"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})));

function SvgApprovalDetailCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgApprovalDetailCard;